import {useEffect, useRef} from "react";
import {getHeadersToken} from "../MonCompteAction";
import {Cart} from "../iMonCompte";
import { getHostApi } from "../../../utils";
import { FormDetectBackground, FormGenerateTexture, ResponseDetectBackground, ResponseGenerateTexture } from "./components/iUpload";
import { ResponseData } from "../../../interfaces-base";

export const bgLikeTextile = (color:string,  opacity: number = 1, weight:number = 6, opacityFibres: number = 0.9) => {
  const pathSvg = 'M5 0h1L0 6V5zM6 5v1H5z';
  const amount = defineIsDarken(color) ? 120 : -100;
  const colorFibres = adjustDarkerOrLighterColor(color, amount);
  const colorRgba = hexToRgba(color, opacity);
  const colorBg = colorRgba && colorRgba !== '' ? colorRgba : color;
  return {background: 'unset',  backgroundColor: colorBg, backgroundImage: `url("data:image/svg+xml,%3Csvg width='${weight}' height='${weight}' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg  fill='%23${colorFibres}' fill-opacity='${opacityFibres}' fill-rule='evenodd'%3E%3Cpath d='${pathSvg}'/%3E%3C/g%3E%3C/svg%3E")`};
}

export const defineIsDarken = (color:string, seuil: number = 0.35) => {
  const hexToHSLVal = hexToHSL(color);
  const isDarkenColor =  hexToHSLVal && hexToHSLVal.l < seuil;
  return isDarkenColor;
}

export const hexToRgba = (color: any, opacity: number = 1) => {
    let codeRGB : any ;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(color)){
      codeRGB= color.substring(1).split('');
      if(codeRGB.length== 3){
        codeRGB= [codeRGB[0], codeRGB[0], codeRGB[1], codeRGB[1], codeRGB[2], codeRGB[2]];
      }
      codeRGB= '0x'+codeRGB.join('');
      return 'rgba('+[(codeRGB>>16)&255, (codeRGB>>8)&255, codeRGB&255].join(',')+','+opacity+')';
    }
    return '';
}

export const adjustDarkerOrLighterColor = (color:string, amount: number, widthPrefixHexa = false) => {
  // amount en pourcentage : valeur positive = couleur plus claire, valeur négative = couleur plus foncée
  const prefix = widthPrefixHexa ? '#' : '';
  const strReturn = color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
  return  widthPrefixHexa ? prefix + strReturn : strReturn;
}

export const optionIsDefined = (data : any) => {
  return data.batAutoRotation > 0 || data.batAutoColor != '' || data.batAutoTrim || data.batAutoRemoveBackground || data.applyOutline;
}

export const badQualityMsg = () => {
  return 'La qualité de votre image est trop faible pour obtenir un résultat satisfaisant. Veuillez importer une autre image.';
}

export const emulateCouleurTextile = (colorHexa:string, outlineProcessingType:string, currentStyle: any = {}) => {
  const arrayColor = Array.from(colorHexa);
  let nextStyle = {};
  if(outlineProcessingType === 'couleurTextile' && arrayColor && arrayColor[0] === '#' && arrayColor.length === 7 ) {
    const pixelContourValue = 5*96/400 ;
    const rgbaBgColor= hexToRgba( colorHexa);
    nextStyle =  {filter: `drop-shadow(${pixelContourValue}px 0px 0px ${rgbaBgColor}) drop-shadow(-${pixelContourValue}px 0px 0px ${rgbaBgColor}) drop-shadow(0px ${pixelContourValue}px 0px ${rgbaBgColor})  drop-shadow(0px -${pixelContourValue}px 0px ${rgbaBgColor})`};
   }
  return  {...currentStyle, ...nextStyle};

}

export const generateFormData = (caddies: Cart[], fileIsUpload : boolean, data: any, rollback: boolean = false, fromGallery: boolean = false) => {
  const formData = new FormData();
  const headers = getHeadersToken();
  headers['Content-Type'] = 'multipart/form-data';
  if(fileIsUpload) {
    formData.append('useFileUpload', 'true');
  } else {
    if(caddies[0].isBeforeUploadReadyToUpload) {
      formData.append('isBeforeUploadReadyToUpload', 'true');
    } else if (data.selectedFile instanceof File) {
      formData.append('file', data.selectedFile);
    } else  {
      formData.append('file', data.selectedFile.fileNameOrigin);
      formData.append('fromOrderId', data.selectedFile.fromOrderId);
      formData.append('galerieFichierId', data.selectedFile.galerieFichierId);
      formData.append('galerieFichierVariableId', data.selectedFile.galerieFichierVariableId);
      formData.append('fromGallery', data.selectedFile.needReupload);
      formData.append('fileNameOrigin', data.selectedFile.fileNameOrigin);
      formData.append('pathFileOrigin', data.selectedFile.pathFileOrigin);
      formData.append('poidsSource', data.selectedFile.poids);
      formData.append('typeMimeSource', data.selectedFile.typeMimeSource);
      formData.append('oldTiffFile', data.selectedFile.oldTiffFile);
    }
  }
  if(data.reuploadByOperator) {
    formData.append('reuploadByOperator', 'true');
  }
  formData.append('caddies', JSON.stringify(caddies));
  const surfaceId = data.surfaceId ? data.surfaceId : data.surface.id;
  formData.append('surfaceId',surfaceId);
  formData.append('surfaceName', data.surface.nom);
  formData.append('emplacementId', data.emplacement.id);
  formData.append('emplacementName',data.emplacement.nom);
  formData.append('picto',data.pictogramme.nom);
  formData.append('marquageLibelle', data.marquage.libelle);
  formData.append('marquageName', data.marquage.nom);
  formData.append('markingId',data.marquage.id);

  formData.append('onlyQuadriluxe',data.order.MarquageClair)
  formData.append('b', 'none');
   if(data.dimensions.length !== 0 && fileIsUpload && !optionIsDefined(data)) {
    formData.append('s', data.dimensions.largeur + 'x' +data.dimensions.hauteur);
  } else if(data.dimensionsModifiees && data.reUseDimensions) {
     formData.append('s', data.dimensionsData?.surface.largeur + 'x' + data.dimensionsData?.surface.hauteur);
    }
  if(data.marquage.libelle === 'Quadriluxe') {
    formData.append('n', 'btransparent');
  }

  if(data.originalFileInfos?.outlineProcessing) {
    formData.append('traitementContours', data.originalFileInfos.outlineProcessing);
  }

  if(!caddies[0].isBeforeUploadReadyToUpload && caddies[0].withBeforeUploadStatusId) {
    formData.append('withBeforeUploadStatusId',String(caddies[0].withBeforeUploadStatusId));
  }

  if(data.marquage.id === 3) {
    const surfaceCmCarre = (data.nbArticles * data.surface.paysage_x * data.surface.paysage_y);
    formData.append('surfaceCmCarre', String(surfaceCmCarre));
  }

  if(rollback) {
    formData.append('rollback', 'true');
  }
  return formData;
}

export function hexToHSL(hex:string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if(result) {
    let r = parseInt(result[1], 16);
    let g = parseInt(result[2], 16);
    let b = parseInt(result[3], 16);
    r /= 255, g /= 255, b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s  = (max + min) / 2;
    const l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h = h ? h /= 6 : null;
    }
    if(h == null) {
      return null;
    }
    return {h: h, s:s, l: l};
  }
  return null;
}

export default function useEventListener(eventName : string, handler : any, element = window) {
  const savedHandler = useRef();
  useEffect(() => {
    savedHandler.current = handler;
  }, [handler]);

  useEffect(
    () => {
      const isSupported = element && element.addEventListener;
      if (!isSupported || !savedHandler || !savedHandler.current) return;

      const eventListener = (event: any) => {
        // @ts-ignore
        return  savedHandler.current(event);
      };

      element.addEventListener(eventName, eventListener);

      return () => {
        element.removeEventListener(eventName, eventListener);
      };
    },
    [eventName, element]
  );
}

export async function generateTexture(
  productId: number, form: FormGenerateTexture
): Promise<ResponseData<ResponseGenerateTexture>> {
  const response = await fetch(`${getHostApi()}/uploads/generate-texture/product/${productId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(form)
  });

  if (response.status >= 400) {
    throw new Error('Un problème est survenu');
  }

  return response.json();
}

export async function detectBackground(
  form: FormDetectBackground
): Promise<ResponseData<ResponseDetectBackground>> {
  const response = await fetch(`${getHostApi()}/uploads/detect-background`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...form
    })
  });

  if (response.status >= 400) {
    throw new Error('Un problème est survenu lors de la transformation de votre fichier');
  }

  return response.json();
}